const identityServerUrl =
    process.env.VUE_APP_IDENTITY_SERVER_URL ||
    'https://identity.gethighered.global/';

export default {
    baseURL: identityServerUrl.concat('api/'),
    template: [
        'IDENTITY_API_GET',
        () => ({
            id: 1337, // Just a random id
        }),
    ],

    '/recover': {
        '/validate': {
            POST: {},
        },
    },
};
